import gsap from "gsap";
import { createFocusTrap } from "focus-trap";  // <--- hier importieren

const toggle = document.querySelector(".menu-toggle");
const toggleSpan = document.querySelectorAll(".menu-toggle span");
const menu = document.querySelector(".menu");

// Fokusfalle initialisieren
const focusTrap = createFocusTrap(menu, {
  initialFocus: () => menu.querySelector('a, button, [tabindex]:not([tabindex="-1"])'),
  escapeDeactivates: true,
  clickOutsideDeactivates: true,
});

const tlMenu = gsap.timeline({
  paused: true,
  reversed: true,
  defaults: {
    ease: "power3.out",
  },
});

gsap.set(menu, { right: "-100%" });

tlMenu
  .to(menu, {
    right: "0",
  })
  .to(
    toggle,
    { rotation: 360, backgroundColor: "var(--toggle-btn-current)" },
    0
  )
  .to(toggleSpan, { backgroundColor: "var(--toggle-icon-current)" }, 0)
  .to(toggleSpan[0], { rotate: 45, y: "-50%", x: "0" }, 0)
  .to(toggleSpan[1], { opacity: 0 }, 0)
  .to(toggleSpan[2], { rotate: -45, y: "-50%", x: "0" }, 0);

const bodyOverlay = document.querySelector(".overlay");

const menuToggleOpen = () => {
  setTimeout(() => {
    bodyOverlay.classList.add("show");

    // Zugänglichkeit aktivieren
    menu.removeAttribute("inert");
    menu.setAttribute("aria-hidden", "false");

    toggle.setAttribute("aria-expanded", "true");
    tlMenu.play();

        // Fokusfalle aktivieren
    focusTrap.activate();
  }, 1);
};

export const menuToggleClose = () => {
  setTimeout(() => {
    bodyOverlay.classList.remove("show");

    // Zugänglichkeit deaktivieren
    menu.setAttribute("inert", "");
    menu.setAttribute("aria-hidden", "true");

    toggle.setAttribute("aria-expanded", "false");
    tlMenu.reverse();

        // Fokusfalle deaktivieren
    focusTrap.deactivate();
  }, 1);
};

export const menuToggleInstant = () => {
  toggle.setAttribute("aria-expanded", "false");

  // Sicherstellen, dass Menü deaktiviert bleibt
  menu.setAttribute("inert", "");
  menu.setAttribute("aria-hidden", "true");

  tlMenu.restart();
  tlMenu.pause();
};

export const menuToggle = () => {
  toggle.addEventListener("click", () => {
    if (toggle.getAttribute("aria-expanded") == "false") {
      menuToggleOpen();
    } else {
      menuToggleClose();
    }
  });

  bodyOverlay.addEventListener("click", () => {
    menuToggleClose();
  });

  // Escape-Taste Listener
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" || event.key === "Esc") {
      if (toggle.getAttribute("aria-expanded") === "true") {
        menuToggleClose();
      }
    }
  });
};




//Submenu Toggle
window.toggleSubMenu = function (event) {
  var clickedElement = event.target;
  if (clickedElement.classList.contains("menu-nav__link")) {
    var menuItem = clickedElement.parentNode;
    var subMenu = menuItem.querySelector(".menu-nav__list--sub");
    var allMenus = document.querySelectorAll(".menu-nav__item");

    allMenus.forEach(function (menu) {
      if (menu !== menuItem) {
        menu.classList.remove("open");
        const otherSubMenu = menu.querySelector(".menu-nav__list--sub");
        if (otherSubMenu) otherSubMenu.style.maxHeight = "0";
      }
    });

    if (menuItem.classList.contains("open")) {
      menuItem.classList.remove("open");
      subMenu.style.maxHeight = "0";
    } else {
      menuItem.classList.add("open");
      subMenu.style.maxHeight = subMenu.scrollHeight + "px";
    }
  }
};
